import React, { type ReactNode } from 'react';
import { useSessionTimeout } from '../../hooks/useSessionTimeout';
import { useSession } from '../../context/session-context';

interface SessionTimeoutWrapperProps {
  children: ReactNode;
}

export const SessionTimeoutWrapper: React.FC<SessionTimeoutWrapperProps> = ({ children }) => {
  const { logout } = useSession();

  // Initialize the idle timer with logout callback
  useSessionTimeout({
    onLogout: logout,
  });

  return <>{children}</>;
};
